export enum COOKIES {
  JWT_TOKEN = 'jwt_token',
  REFRESH_TOKEN = 'refresh_token'
}
